import { render } from "./ModalComponentBody.vue?vue&type=template&id=77b618e6&scoped=true"
const script = {}

import "./ModalComponentBody.vue?vue&type=style&index=0&id=77b618e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b618e6"]])

export default __exports__